import { render } from "./Hospital.vue?vue&type=template&id=6950a50c&scoped=true"
import script from "./Hospital.vue?vue&type=script&lang=js"
export * from "./Hospital.vue?vue&type=script&lang=js"

import "./Hospital.vue?vue&type=style&index=0&id=6950a50c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6950a50c"]])

export default __exports__